module.exports = __webpack_public_path__ + "static/img/phone.0128b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience/phone.png
// module id = kCRX
// module chunks = 1